import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { LogoSquareModule } from '@libs/src/logo-square/logo-square.module';

import { FooterComponent } from '@static-client/src/app/footer/footer.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    LogoSquareModule,
    RouterModule.forChild([]),
  ],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
